export const notesEntityFilters = [
  {
    type: "people" as "people" | "operators" | "lists" | "widgets",
    labelKey: "FILTERS.PEOPLE",
  },
  {
    type: "operators" as "people" | "operators" | "lists" | "widgets",
    labelKey: "FILTERS.OPERATORS",
  },
  {
    type: "lists" as "people" | "operators" | "lists" | "widgets",
    labelKey: "FILTERS.LISTS",
  },
  {
    type: "widgets" as "people" | "operators" | "lists" | "widgets",
    labelKey: "FILTERS.WIDGETS",
  },
];